

export const SAMPLE_DRAFT_SECTIONS = [
  
];

export const KNOWLEDGE_SCOPES = [
  "Complete Knowledge Base",
  "This Project Only",
  "Selected Documents",
];

export const DEFAULT_KNOWLEDGE_SCOPE = "Complete Knowledge Base";
